import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Alert,
    ButtonGroup,
    Col,
    Row
} from 'reactstrap';

import PolyUtil from '../../../util/PolyUtil';
import {handleRejectInvitation, handleAcceptInvitation} from '../actions/roommates';
import {AsyncButton} from "../../../components/controls/buttons/AsyncButton";

class TenantNotifications extends Component {
    render() {

        const invitations = PolyUtil.validArr(this.props.invitations) && this.props.invitations;
        const {_handleAcceptInvitation, _handleRejectInvitation} = this.props;

        if (invitations) {
            return (
                <div style={{marginTop: '4em'}}>
                    <Row>
                        <Col>
                            <h3>Notifications</h3>
                        </Col>
                    </Row>

                    <hr/>
                    {
                        invitations.map(function (invitation, i) {
                            return (
                                <Row key={i}>
                                    <Col>
                                        <Alert color="info" className="center" style={{width: '100%'}}>
                                            <h5>You have been invited to a group by {invitation.coordinator.get_first_name + ' ' + invitation.coordinator.get_last_name}</h5>
                                            <ButtonGroup>
                                                <AsyncButton task={() => _handleRejectInvitation(invitation.id)} color="danger">Reject</AsyncButton>
                                                <AsyncButton task={() => _handleAcceptInvitation(invitation.id)} color="success">Accept</AsyncButton>
                                            </ButtonGroup>
                                        </Alert>
                                    </Col>
                                </Row>
                            );
                        })
                    }
                </div>
            );
        } else return null;
    }
}

const mapStateToProps = (state) => ({
    invitations: state.tenant.invitations
});

const mapDispatchToProps = (dispatch) => {
    return {
        _handleRejectInvitation(id) {
            return dispatch(handleRejectInvitation(id));
        },
        _handleAcceptInvitation(id) {
            return dispatch(handleAcceptInvitation(id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TenantNotifications);


// WEBPACK FOOTER //
// ./src/containers/tenant/dashboard/TenantNotifications.js